import { render } from "./manage_approval_rules.html?vue&type=template&id=0f8d8b52&external"
import script from "./manage_approval_rules.js?vue&type=script&lang=js&external"
export * from "./manage_approval_rules.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__